// Third-party imports

// Local imports
import { scroll } from '../util/animation.js';
//import * as domelement from '../util/domelement.js';

// Module name
export const MODULE_NAME = 'smoothscroll';

export let global_vars = {};

export function initialize(global) {
    init_scroll_handler(global);
}

// TODO: this will scroll to just after the header. Should this not be right to
// the very top?
function init_scroll_handler(global) {
    let selector = '.smoothScroll:not(.smoothScroll--disabled)';
    let all_scroll_el = global.document.querySelectorAll(selector);
    for (let scroll_el of all_scroll_el) {
        scroll_el.addEventListener('click', event => {
            event.preventDefault();

            // We want to scroll all the way to the top
            /*let header = global.document.querySelector('.siteHeader');
            let header_height = domelement.is_visible(header)
                ? header.offsetHeight
                : 0;*/
            scroll(global.document.body, 0, 600);
            // Bring focus to the first focusable element
            let top_el = global.document.querySelector('.skipContent');
            top_el.focus();
        });
    }

    let disabled_selector = '.smoothScroll--disabled';
    let all_noscroll_el = global.document.querySelectorAll(disabled_selector);
    for (let el of all_noscroll_el) {
        el.addEventListener('click', event => {
            event.preventDefault();
        });
    }
}
